import { useState } from "react";
import { Play } from "lucide-react";
import thumbnail from "../../assets/images/Saas_theme.webp";

const TutorialVideo = () => {
  const [play, setPlay] = useState(false);

  if (play) {
    return (
      <video
        className="w-full aspect-video rounded-xl"
        src="https://deviinfrared1.blob.core.windows.net/infrared-dev/xynexaivideo%20(2)%20(1).mp4"
        poster={thumbnail}
        controls
        autoPlay
        muted
        playsInline
        preload="metadata"
      />
    );
  }

  return (
    <div
      onClick={() => setPlay(true)}
      className="relative w-full aspect-video cursor-pointer group rounded-2xl overflow-hidden"
    >
      <img
        src={thumbnail}
        alt="XynexAI product demo"
        className="w-full h-full object-cover"
        loading="lazy"
      />

      <div className="absolute inset-0 bg-black/40" />

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-16 h-16 md:w-20 md:h-20 bg-white/90 rounded-full flex items-center justify-center group-hover:scale-110 transition">
          <Play className="w-7 h-7 md:w-9 md:h-9 text-black ml-1" />
        </div>
      </div>
    </div>
  );
};


export default TutorialVideo;